<style scoped>
.field-fancyCheckbox label {
  opacity: 0 !important;
}
</style>

<template>
  <b-form-group>
    <b-form-checkbox
      v-model="value"
      :disabled="disabled"
      :name="schema.model"
      :required="schema.required"
      ref="checkbox"
    >
      {{ schema.text }}
    </b-form-checkbox>
  </b-form-group>
</template>

<script>
import { abstractField } from 'vue-form-generator';

export default {
  mixins: [abstractField],
  methods: {
    setErrorState(value) {
      if (value === true) {
        this.$refs.checkbox.$refs.input.classList.add('invalid-input');
      } else {
        this.$refs.checkbox.$refs.input.classList.remove('invalid-input');
      }
    },
  },
  watch: {
    errors(value) {
      this.setErrorState(value.length !== 0);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/custom_fields/general/fieldFancyCheckbox.vue